import _ from "lodash";
import moment from "moment";
import React, { Component, Suspense, lazy } from "react";
import { withRouter } from "react-router-dom";
import "./css/App.css";
import "./css/Ant.css"
import "./css/main.css"
import "./css/mobile_main.css"
import "./css/tablet_main.css"

import {
  getCurrentUser,
  getCurrentVendor,
  getTermsOfUseDate,
  getCurrentBranch,
} from "./services/users_service";
import { getMessage } from "./constants/messages.js";
import { Loader } from "semantic-ui-react";
import { getBranches, switchBranch } from "./services/users_service";
import { message } from "antd";
const PublicHome = lazy(() => import("./components/public_home_component"));
const PrivateHome = lazy(() => import("./components/private_home_component"));

class App extends Component {
  state = {
    isLogin: false,
    auth: {}, // we will deprecate isLogin next time
  };

  componentDidMount() {
    let isLogin = localStorage.getItem("token") != null;
    let auth = JSON.parse(localStorage.getItem("auth"));
    this.setState({ isLogin, auth });
    // if (isLogin) {
    //   this.props.history.push("/products");
    // }
  }

  logout = () => {
    const { history } = this.props;
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("auth");
    localStorage.removeItem("require_password_change");
    localStorage.removeItem("vendor_enforce_password_change");
    localStorage.removeItem("isTaxEnabled");
    this.setState({ isLogin: false });
    history.push("/login");
  };

  login = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const user = await getCurrentUser();
        const vendor = await getCurrentVendor();
        const date = await getTermsOfUseDate();

        let rolesAllow = ["admin", "purchaser", "picker", "checker", "driver", "data_manager", "manager", "salesman", "sales_manager", "salesman_admin", "finance_manager", "finance_specialist", "pos_specialist", "lead_store", "supervisor", "kasuki_manager", "kasuki_specialist", "service_representative", "logistic_manager", "customer_service"]

        const isUserRoleMatch = (role) => user?.roles?.includes(role)

        const isAllowed = rolesAllow.some(isUserRoleMatch)
        if(!isAllowed) { 
          message.error("Invalid Credentials")
          return this.logout()
        }


        let userFields = _.pick(user, [
          "firstname",
          "lastname",
          "email",
          "roles",
          "branch_id",
          "branch_ids",
          "tags"
        ]);

        const { firstname, lastname } = user;
        const full_name = `${firstname} ${lastname}`;
        userFields = { ...userFields, full_name };

        let {
          _id,
          name,
          code,
          business_type,
          branches,
          settings,
          sla,
          price_lists,
        } = vendor;

        // Handling of active branch
        let branch_id = user.branch_id;
        let active_branch = _.find(branches, (b) => b._id === branch_id);

        //  in case no branch is indicated
        if (!active_branch || active_branch.status === "D") {
          if (user.roles.includes("admin")) active_branch = branches[0];
          else throw Error(getMessage("no_branch_access"));
        }

        const havePriceList = price_lists.filter(
          (item) => item._id === active_branch.price_list_id
        );

        if (_.isEmpty(havePriceList)) {
          const { branches } = await getBranches();
          const response = await switchBranch(branches[0]._id);

          active_branch = response;
        }

        const info = _.defaultTo(vendor.info, {});
        // should we require use to accept terms of use
        const terms_of_use_expired =
          _.isEmpty(info.terms_of_use_accepted_at) ||
          moment(date).isAfter(info.terms_of_use_accepted_at);

        if (!settings.enable_multi_branch) {
          const { branches } = await getBranches();
          const getFilteredId = branches[0]._id === userFields.branch_id;
          if (!getFilteredId) {
            const response = await switchBranch(branches[0]._id);
            active_branch = response;
          }
        }

        let vendorFields = {
          vendor_id: _id,
          vendor_name: name,
          vendor_code: code,
          business_type,
          active_branch,
          settings,
          sla,
          terms_of_use_expired,
          price_lists: price_lists,
        };
        const inventory = await getCurrentBranch(user.branch_id);

        vendorFields = {
          ...vendorFields,
          settings: {
            ...vendorFields.settings,
            ...inventory
          },
        };

        localStorage.setItem("enable_gas_refill_feature", vendorFields?.settings?.my_driver_app?.enable_gas_refill_feature || false)

        const auth = {
          ...userFields,
          ...vendorFields,
        };
        localStorage.setItem("auth", JSON.stringify(auth));
        this.setState({ isLogin: true, auth });

        resolve();
      } catch (err) {
        reject(err);
      }
    });
  };

  setAuthState = (props, inventory) => {
    let auth = JSON.parse(localStorage.getItem("auth"));

    auth = { ...auth, ...props };

    auth = {
      ...auth,
      settings: {
        ...auth.settings,
        ...inventory,
      },
    };
    // setTimeout(() => {
    this.setState({ auth });
    localStorage.setItem("auth", JSON.stringify(auth));
    // }, 300);
  };

  checkRender = () => {
    if (this.state.isLogin && this.state.auth) {
      return (
        <Suspense fallback={<Loader />}>
          <PrivateHome
            logout={this.logout}
            isLogin={this.state.isLogin}
            auth={this.state.auth}
            setAuthState={this.setAuthState}
            history={this.props.history}
          />
        </Suspense>
      );
    } else {
      if (
        window.location.href.indexOf("login") > -1 ||
        window.location.href.indexOf("signup") > -1 ||
        window.location.href.indexOf("forgot-password") > -1 ||
        window.location.href.indexOf("reset-password") > -1 ||
        window.location.href.indexOf("legal/terms-of-service") > -1 ||
        window.location.href.indexOf("legal/privacy-policy") > -1
      ) {
        return (
          <Suspense fallback={<Loader />}>
            <PublicHome login={this.login} isLogin={this.state.isLogin} />
          </Suspense>
        );
      } else {
        var __html = require("../www/index.html");
        var template = { __html: __html };
        return <div dangerouslySetInnerHTML={template} />;
      }
    }
  };

  render() {
    return this.checkRender();
  }
}

export default withRouter(App);
